import { Button } from 'rsuite'
import { forwardRef } from 'react'
import { PiDotsSixVerticalBold } from 'react-icons/pi'
import cn from 'classnames'
import styles from './exploreButton.module.scss'

const Link = forwardRef(function Link({ children, className, ...props }, ref) {
  return (
    <Button ref={ref} className={cn(styles.exploreButton, className)} {...props}>
      {children}
    </Button>
  )
})

const ExploreButton = forwardRef(function ExploreButton(props, ref) {
  return (
    <Link ref={ref} {...props}>
      <PiDotsSixVerticalBold className="icon" size={30} />
      <span>{props.children}</span>
    </Link>
  )
})

export default ExploreButton
